import { useState } from "react";
import { Lock } from "lucide-react";

export default function ProGate({ tryUnlock, label="full track record" }) {
  const [code, setCode] = useState("");
  const [err,  setErr]  = useState(false);
  const handle = () => { if (!tryUnlock(code)) setErr(true); };
  return (
    <div style={{background:"#0A0A0A",border:"1px solid rgba(201,168,76,0.15)",borderRadius:16,padding:"44px 24px",textAlign:"center",marginTop:8}}>
      <div style={{marginBottom:14,display:"flex",justifyContent:"center"}}><Lock size={36} strokeWidth={1.5} color="#e8c875"/></div>
      <div style={{fontFamily:"'Cinzel',serif",fontSize:20,fontWeight:700,color:"#fff",marginBottom:10}}>Pro Subscribers Only</div>
      <div style={{fontSize:13,color:"rgba(255,255,255,0.78)",maxWidth:360,margin:"0 auto 28px",lineHeight:1.65}}>
        Enter your access code to unlock the {label}.
      </div>
      <div style={{display:"flex",gap:8,maxWidth:360,margin:"0 auto"}}>
        <input type="password" placeholder="Access code"
          value={code} onChange={e=>{setCode(e.target.value);setErr(false)}}
          onKeyDown={e=>e.key==="Enter"&&handle()}
          style={{flex:1,padding:"11px 16px",fontSize:14,background:"#111",border:`1px solid ${err?"#FF3B30":"rgba(201,168,76,0.25)"}`,borderRadius:10,color:"#fff",outline:"none",fontFamily:"inherit"}}/>
        <button onClick={handle}
          style={{padding:"11px 20px",fontSize:13,fontWeight:700,background:"linear-gradient(135deg,#e8c875,#ffe87a)",color:"#000",borderRadius:10,border:"none",cursor:"pointer",whiteSpace:"nowrap"}}>
          Unlock →
        </button>
      </div>
      {err && <div style={{color:"#FF3B30",fontSize:12,marginTop:10}}>Invalid code — check your subscription confirmation email.</div>}
      <div style={{marginTop:20}}>
        <a href="/subscribe" style={{fontSize:12,color:"rgba(201,168,76,0.5)"}}>Don't have a code? Subscribe →</a>
      </div>
    </div>
  );
}

export function useProAccess() {
  const tryUnlock = () => true;
  return { unlocked: true, tryUnlock };
}
